import { ParticipantList } from './'
import { Box } from '../../widgets'
import './SquizScreen.scss'
import { forwardRef } from 'react'

export const SquizScreen = forwardRef(function SquizScreen({ centered, fade, participants, participantsDesktopOnly = true, fullWidth, fullHeightContent = true, children }, ref) {
  return (
    <Box className={`squiz-screen${participants ? ' show-participants' : ''}${centered ? ' centered' : ''}`} userSelect="none">
      <Box
        className="squiz-content"
        background={fade && 'var(--black-fade)'}
        fullWidth={fullWidth}
        fullHeight={fullHeightContent}
      >
        <Box>
          {children}
        </Box>
      </Box>
      <Box className={`participants${participantsDesktopOnly ? ' desktop-only' : ''}`}>
        <ParticipantList ref={ref} />
      </Box>
    </Box>
  )
})